import { RouteConfig } from 'vue-router';
import MswAtpTraining from './msw-atp-training.vue';

const route:RouteConfig = {
  path: 'atp-training',
  component: MswAtpTraining,
};

export function getDefaultParams() {
  return {};
}

export default route;
